<template>
	<v-layout row wrap>
		<v-flex md4 body-border-right body-border-right-full pr-3>
			<table-run
				v-bind:columns="columns"
				v-bind:rows="rows"
				v-bind:include-delete="false"
				v-bind:include-options="true"
				v-bind:include-export-to-excel="false"
				v-bind:selectable="false"
				v-on:on-sortable-event="columnSortableEvent"
				v-on:on-search-event="searchByColumn"
				class="no-selectable-table table-custom-options">
				<template slot="rows" scope="props">
					<td :class="{ 'active': props.row.classActive }">
						<button
							type="button"
							v-on:click="selectHousemaid(props.row, roomsPage = 1)"
							class="button-transparent text-xs-left">
							{{props.row.name}} {{props.row.lastname}}
						</button>
						<router-link
							v-if="props.row.classActive"
							:to="housemaidProfileHref"
							class="btn-to-profile">
							Ver perfil <v-icon>keyboard_arrow_right</v-icon>
						</router-link>
					</td>
					<td class="text-xs-right pr-2 options-column options-column-housemaids" :class="{ 'active': props.row.classActive }">
						<span :class="`circle-state state-${props.row.com_ms_state_emp_id}`"></span>
						<span>{{ props.row.room_assigned }} hab.</span>
					</td>
				</template>
			</table-run>
			<v-layout row wrap justify-end mt-3>
				<v-pagination
					v-bind:length="totalPages"
					:total-visible="pagesVisible"
					v-model="page"
					v-on:input="changePage">
				</v-pagination>
			</v-layout>
		</v-flex>
		<v-flex md8 pl-3>
			<v-layout row wrap>
				<v-container fluid v-bind="{ ['grid-list-lg'] : true }" body-border-bottom pb-2>
					<v-layout row wrap>
						<v-flex md3 pt-2>
							<v-select
								class="filter-select"
								v-bind:items="buildings"
								item-text="name"
								item-value="id"
								v-bind:disabled="!model.selectedHousemaidId"
								v-model="model.buildingId"
								hide-details
								label="Edificio"
								v-on:change="loadFloors"
								single-line
								bottom></v-select>
						</v-flex>
						<v-flex md3 pt-2>
							<v-select
								class="filter-select"
								v-bind:items="floors"
								v-model="model.floorId"
								v-bind:disabled="floors.length === 0"
								hide-details
								v-on:change="filterRooms"
								label="Piso"
								single-line
								bottom></v-select>
						</v-flex>
						<v-flex md3 pt-2>
							<v-select
								class="filter-select"
								v-bind:items="roomTypes"
								item-text="name"
								item-value="id"
								v-bind:disabled="!model.selectedHousemaidId"
								v-model="model.roomTypeId"
								hide-details
								v-on:change="filterRooms"
								label="Tipo de habitación"
								single-line
								bottom></v-select>
						</v-flex>
						<v-flex md3 pt-2>
							<button-create :text="'Mucama'" :href="createHousemaidHref"></button-create>
						</v-flex>
					</v-layout>
					<v-layout row wrap>
						<v-flex md4>
							<v-menu
								lazy
								v-model="menu"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker"
								:nudge-left="40"
								max-width="290px"
								v-on:input="changeIcon"
							>
								<v-text-field
									slot="activator"
									label="Picker in menu"
									v-model="model.filterDate"
									prepend-icon="event"
									:append-icon="onChange ? 'arrow_drop_up' : 'arrow_drop_down'"
									:append-icon-cb="() => (onChange = !model.filterDate)"
									single-line
									hide-details
									readonly
								></v-text-field>
								<v-date-picker
									v-model="model.filterDate"
									v-on:input="filterRooms"
									locale="es"
									no-title
									scrollable>
								</v-date-picker>
							</v-menu>
						</v-flex>
					</v-layout>
				</v-container>
			</v-layout>
			<v-layout row wrap>
				<v-container fluid v-bind="{ ['grid-list-lg'] : true }" body-border-bottom pb-2 pt-3>
					<v-layout row wrap>
						<p class="medium pl-2">Seleccione el supervisor:</p>
					</v-layout>
					<v-layout row wrap>
						<user-selector-list
							class="pl-2"
							:users="supervisors"
							v-on:on-change-selected="supervisorSelected"></user-selector-list>
					</v-layout>
				</v-container>
			</v-layout>
			<v-layout row wrap>
				<v-container fluid v-bind="{ ['grid-list-lg'] : true }" body-border-bottom pb-2 pt-3>
					<v-layout row wrap>
						<p class="medium pl-2">Seleccione la habitación:</p>
					</v-layout>
					<v-layout row wrap pl-2>
						<room-number-list
							v-for="(room, indexRoom) in rooms"
							:key="room.id"
							:tag="'label'"
							:index="indexRoom"
							v-on:on-room-selected="addRoomSelected"
							:labelFor="`rooms-${room.id}`"
							:room="room"></room-number-list>
					</v-layout>
					<v-layout row wrap justify-end mt-3>
						<v-pagination
							v-if="rooms && rooms.length > 0"
							v-bind:length="totalRoomsPages"
							:total-visible="roomsPagesVisible"
							v-model="roomsPage"
							v-on:input="changeRoomsPage">
						</v-pagination>
					</v-layout>
				</v-container>
			</v-layout>
			<v-layout row wrap>
				<v-container fluid v-bind="{ ['grid-list-lg'] : true }" pb-2 pt-3 text-xs-right>
					<v-btn
						v-if="rooms && rooms.length > 0"
						v-bind:disabled="dataIncomplete"
						class="btn-assign-tasks"
						v-on:click="sendDataToAssign">
						Asignar
					</v-btn>
				</v-container>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import TableRun from 'table-run';
	import mixin from '@/shared/mixins';
	import helper from '@/shared/helper';
	import housemaidResource from '@/resource/housemaid';
	import ButtonCreate from '@/components/shared/ButtonCreate';
	import UserSelectorList from '@/components/shared/UserSelectorList';
	import RoomNumberList from '@/components/shared/RoomNumberList';

	const date = new Date();
	const helperMethods = helper.methods;

	const currentDate = {
		day: date.getDate(),
		month: date.getMonth() < 9 ? `0${date.getMonth()}` : date.getMonth() + 1,
		today: date.toISOString().substr(0, 10),
		value: date,
		year: date.getFullYear(),
	};

	function created() {
		this.resource = housemaidResource(this);
		this.loadBuildings();
		this.loadRoomTypes();
		this.loadData();
	}

	function addRoomSelected(room, index) {
		if (room.isSelected) {
			this.model.rooms.push(room);
		} else {
			this.model.rooms.splice(index, 1);
		}
	}

	function changeIcon(result) {
		this.onChange = result;
	}

	async function changePage(value) {
		this.page = value;
		this.loadData(null, null, value);
		this.supervisors = [];
		this.rooms = [];
	}

	async function changeRoomsPage(value) {
		this.roomsPage = value;
		this.selectHousemaid(this.model.selectedHousemaid, value, null, true);
	}

	function columnSortableEvent({ id }) {
		const self = this;
		const newColumn = self.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		self.columns = self.columns.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
			return newColumnSingle;
		});
		const sortGroupAsc = [
			{
				key: newColumn[0].code,
				direction: newColumn[0].isSortable.up ? 'ASC' : 'DSC',
			},
		];
		this.loadData(null, sortGroupAsc);
	}

	function filterRooms() {
		this.roomsPage = 1;
		setTimeout(() => {
			this.selectHousemaid(this.model.selectedHousemaid, this.roomsPage, this.filtersRooms, true);
		}, 300);
	}

	async function loadData(filterGroups, sortGroup, page) {
		const parameters = {};
		if (filterGroups) {
			parameters.filter_groups = filterGroups;
		}
		if (sortGroup) {
			parameters.sort = sortGroup;
		}
		if (page) {
			parameters.page = page;
		}
		const response = await this.resource.list(parameters);
		this.totalPages = response.data.last_page;
		this.items = this.loadSubsidiaries();
		this.rows = response.data.data.map((row) => {
			const newRow = Object.assign({}, row);
			if ((row.com_ms_state_emp_id > 1 &&
				row.com_ms_state_emp_id < 6) ||
				row.com_ms_state_emp_id === 7) {
				newRow.com_ms_state_emp_id = 2;
			} else if (row.com_ms_state_emp_id === 6) {
				newRow.com_ms_state_emp_id = 3;
			} else {
				newRow.com_ms_state_emp_id = row.com_ms_state_emp_id;
			}
			newRow.classActive = false;
			return newRow;
		});
	}

	function loadFloors(id) {
		this.buildings.forEach((building) => {
			if (building.id === id) {
				this.floors = Array(building.floors);
			}
		});
		for (let i = 0; i < this.floors.length; i += 1) {
			this.floors[i] = i + 1;
		}
		this.model.floorId = 0;
		this.roomsPage = 1;
		setTimeout(() => {
			this.selectHousemaid(this.model.selectedHousemaid, this.roomsPage, this.filtersRooms, true);
		}, 300);
	}

	function pagesVisible() {
		return this.totalPages < 5 ? this.totalPages : 5;
	}

	function roomsPagesVisible() {
		return this.totalRoomsPages < 5 ? this.totalRoomsPages : 5;
	}

	function searchByColumn(search) {
		const filterGroup = [
			{
				or: true,
				filters: [
					{
						key: 'name',
						value: search,
						operator: 'ct',
					},
					{
						key: 'lastname',
						value: search,
						operator: 'ct',
					},
				],
			},
		];
		this.loadData(filterGroup);
	}

	async function selectHousemaid(housemaid, roomPage, filterGroups, keepRoomsSelected) {
		if (housemaid) {
			this.housemaidProfileHref = { name: 'housemaids-profile', params: { id: housemaid.id } };
			this.model.selectedHousemaid = housemaid;
			this.model.selectedHousemaidId = housemaid.id;
			this.rows = this.rows.map((row) => {
				const newRow = Object.assign({}, row);
				if (row.id === housemaid.id) {
					newRow.classActive = true;
				} else {
					newRow.classActive = false;
				}
				return newRow;
			});
			const parameters = {
				housemaid_id: housemaid.id,
				limit: 30,
				date_clear: this.model.filterDate,
			};
			if (roomPage) {
				parameters.page = roomPage;
			}
			if (filterGroups) {
				parameters.filter_groups = filterGroups;
			} else {
				this.model.buildingId = 0;
				this.floors = [];
				this.model.floorId = 0;
				this.model.roomTypeId = 0;
				if (!keepRoomsSelected) {
					this.model.rooms = [];
				}
			}
			const response = await this.resource.housekeepingRooms(parameters);
			this.totalRoomsPages = response.data.rooms.last_page;
			if (this.model.filterDate < currentDate.today) {
				this.rooms = response.data.rooms.data.map((room) => {
					const newRoom = Object.assign({}, room);
					newRoom.code_room = room.number;
					newRoom.isAssigned = true;
					return newRoom;
				});
			} else {
				this.rooms = response.data.rooms.data.map((room) => {
					const newRoom = Object.assign({}, room);
					newRoom.code_room = room.number;
					if (!room.com_employee_id) {
						newRoom.isSelected = false;
					} else if (room.com_employee_id === housemaid.id) {
						newRoom.isSelected = true;
					} else {
						newRoom.isAssigned = true;
					}
					if (keepRoomsSelected) {
						this.model.rooms.forEach((modelRoom) => {
							if (room.id === modelRoom.id) {
								newRoom.isSelected = true;
							}
						});
					}
					return newRoom;
				}, this);
			}
			this.supervisors = response.data.supervisor;
		} else {
			this.model.filterDate = currentDate.today;
			this.showNotification('Los filtros solo se pueden usar después de elegir una mucama para asignar');
		}
	}

	function sendDataToAssign() {
		this.model.roomTypes = this.roomTypes;
		helperMethods.saveHousemaidAssign(this.model);
		this.$router.push(this.housemaidAssignHref);
	}

	function supervisorSelected(user) {
		this.model.currentSupervisor = user;
	}

	function filtersRooms() {
		const paramsUrl = [];
		const buildingFilter = {
			filters: [
				{
					key: 'hot_building_id',
					value: this.model.buildingId,
					operator: 'eq',
				},
			],
		};
		const floorFilter = {
			filters: [
				{
					key: 'hot_floor_id',
					value: this.model.floorId,
					operator: 'eq',
				},
			],
		};
		const roomtypeFilter = {
			filters: [
				{
					key: 'hot_ms_roomtype_id',
					value: this.model.roomTypeId,
					operator: 'eq',
				},
			],
		};
		if (this.model.buildingId > 0) {
			paramsUrl.push(buildingFilter);
		}
		if (this.model.floorId > 0) {
			paramsUrl.push(floorFilter);
		}
		if (this.model.roomTypeId > 0) {
			paramsUrl.push(roomtypeFilter);
		}
		return paramsUrl;
	}

	function dataIncomplete() {
		let sendData = false;
		Object.keys(this.model).forEach((key) => {
			if ((!this.model[key] && this.model[key] !== 0) || this.model[key].length === 0) {
				sendData = true;
			}
		});
		return sendData;
	}

	export default {
		components: {
			ButtonCreate,
			RoomNumberList,
			TableRun,
			UserSelectorList,
		},
		computed: {
			dataIncomplete,
			filtersRooms,
			pagesVisible,
			roomsPagesVisible,
		},
		created,
		data() {
			return {
				cleanTypes: [{ id: 1, name: 'Normal' }, { id: 2, name: 'Profunda' }],
				columns: [
					{ id: 1, name: 'Nombres', code: 'name', isSortable: { down: true, up: false } },
				],
				createHousemaidHref: { name: 'users-new' },
				filterValue: 1,
				floors: [],
				helperMethods: null,
				housemaidAssignHref: { name: 'housemaids-assign' },
				housemaidProfileHref: {},
				loading: false,
				menu: false,
				model: {
					filterDate: currentDate.today,
					floorId: 0,
					currentSupervisor: null,
					roomTypeId: 0,
					selectedHousemaid: null,
					selectedHousemaidId: null,
					buildingId: 0,
					rooms: [],
				},
				onChange: false,
				page: 1,
				resource: null,
				rooms: null,
				roomsPage: 1,
				rows: [],
				supervisors: [],
				totalPages: 5,
				totalRoomsPages: null,
			};
		},
		methods: {
			addRoomSelected,
			changeIcon,
			changePage,
			changeRoomsPage,
			columnSortableEvent,
			filterRooms,
			loadData,
			loadFloors,
			searchByColumn,
			selectHousemaid,
			sendDataToAssign,
			supervisorSelected,
		},
		mixins: mixin,
		name: 'housemaids-list',
	};
</script>

<style lang="scss" scoped>
	.options-column {
		display: none;

		&.options-column-housemaids {
			display: flex !important;
			justify-content: space-around;

			span {
				display: inline-flex;
			}
		}
	}

	.btn-to-profile {
		color: map-get($colors, bg-chart);
		display: block;
		font-family: map-get($fonts, semibold);
		font-size: map-get($sizes, eleven);

		i {
			font-size: 15px;
			vertical-align: top;
			width: 8px;
		}
	}

	.medium {
		color: map-get($colors, default-dark);
		font-family: map-get($fonts, medium);
	}
</style>



// WEBPACK FOOTER //
// List.vue?c9690268